import ProfileEditAdvisor from '@/components/profile/advisor/ProfileEditAdvisor';
import ProfileEditStaff from '@/components/profile/staff/ProfileEditStaff';
import { useAuthUser } from '@/hooks/stores/useAuthUser';

export default function ProfileEdit() {
  const { isStaff } = useAuthUser();

  if (isStaff) {
    return <ProfileEditStaff />;
  }

  return <ProfileEditAdvisor />;
}
